const cabins = [
  {
    cabinName: '公务舱',
    cabinCode: 'business',
    cabinLevel: 'C'
  },
  {
    cabinName: '经济舱',
    cabinCode: 'economy',
    cabinLevel: 'Y'
  }
]

const benefits = [
  {
    code: 'FREE_LUGGUE',
    icon: 'icon-life-fi-trunk',
    name: '免费托运行李'
  },
  {
    code: 'CARRY_LUGGUE',
    icon: 'icon-gongjuxiang',
    name: '手提行李',
    type: 'longText'
  },
  {
    code: 'JP_REWARD_POINTS',
    icon: 'icon-jifen2',
    name: '积分'
  },
  {
    code: 'HIGH_JP_REWARD_POINTS',
    icon: 'icon-jifen2',
    name: '高额金鹏积分'
  },
  {
    code: 'FOOD_IN_THE_AIR',
    icon: 'icon-can',
    name: '免费餐食'
  },
  {
    code: 'MEAL',
    icon: 'icon-can',
    name: '免费餐食'
  },
  {
    code: 'CABIN_SERVICE',
    icon: 'icon-smile',
    name: '服务',
    type: 'longText'
  },
  {
    code: 'ADVANCE_FREE_CHANGE',
    icon: 'icon-xunhuan',
    name: '免费改期',
    type: 'longText'
  },
  {
    code: 'UPMARKET_CHECK_IN_DESK',
    icon: 'icon-jiedai',
    name: '专属值机柜台',
    type: 'longText'
  },
  {
    code: 'HOUR72_FREE_CHANGE',
    icon: 'icon-xunhuan',
    name: '退改',
    type: 'longText'
  },
  {
    code: 'DISCOUNT_ONBOARD_UP_CABIN',
    icon: 'icon-xunhuan',
    name: '优惠机上升舱'
  },
  {
    code: 'CHEAP_REFUND_CHANGE_SIGEN',
    icon: 'icon-xunhuan',
    name: '优惠退改签'
  },
  {
    code: 'PRIORITY_SECURITY_CHECK_CHANNEL',
    icon: 'icon-anjianchu1',
    name: '优先安检通道'
  },
  {
    code: 'HIGHT_PIORITY_CHECK_IN',
    icon: 'icon-feiji1',
    name: '优先登机'
  },
  {
    code: 'VIP_ROOM',
    icon: 'icon-shafa',
    name: '贵宾候机室'
  },
  {
    code: 'JJC_SEAT',
    icon: 'icon-smile',
    name: '经济舱座位'
  },
  {
    code: 'BUSSINES_CHECK_IN_DESK',
    icon: 'icon-jiedai',
    name: '专属值机柜台'
  }
]

const productMap = {
  ZKGWC: 'zkgwc',
  THGWC: 'thgwc',
  KZGWC: 'kzgwc',
  ZXJJC: 'zxjjc',
  CZJJC: 'czjjc',
  ZKJJC: 'zkjjc'
}

const passengerTypeLanguageMap = {
  'ADULT': '成人',
  'CHILD': '儿童',
  'INFANT': '婴儿'
}

const passengerTypeMap = {
  'ADT': 'ADULT',
  'CHD': 'CHILD',
  'INF': 'INFANT',
  'MWD': 'MWD',
  'PWD': 'PWD'
}

export {
  cabins,
  benefits,
  productMap,
  passengerTypeLanguageMap,
  passengerTypeMap
}
